import colorbrewer from 'colorbrewer';
import { getSquaresHierarchy } from './selectors';


export const animals    = ['elephant', 'rhino', 'hippo', 'bear', 'cow', 'dog', 'cat', 'mouse'];
export const directions = [-1, 0, 1];
export const defaultPalette    = colorbrewer.Set2[8];
export const palettes   = colorbrewer;//Object.keys(colorbrewer).filter(key => colorbrewer[key][8] !== undefined).reduce( (acc, key) => { acc[key] = colorbrewer[key][8]; return acc}, {});

export const randomColor     = (p = defaultPalette) =>   Math.floor(Math.random() * p.length); // 'red';
export const randomAnimal    = (a = animals)        =>   Math.floor(Math.random() * a.length); // 'elephant';
export const randomDirection = (d = directions)     => d[Math.floor(Math.random() * d.length)]; // 1;

export const PROPERTIES = ['depth', 'animal', 'fill', 'direction'];

export const fieldMap = {
  mirror : 'direction',
  brush : 'fill',
  wand : 'animal',
  alarm : 'alarm',
}

export const transformations = {

  "elephant":{"height":69.49455261230469,"width":98.48648834228516,"x":0.64000004529953,"y":18.20745277404785, "orientation" : 1,},
  "rhino":{"height":51.810997009277344,"width":90.37899017333984,"x":2.4170007705688477,"y":27.371994018554688, "orientation" : -1,},
  "hippo":{"height":42.63800048828125,"width":94.30599975585938,"x":28.871002197265625,"y":8.958999633789062, "orientation" : -1,},
  "bear":{"height":264.3686828613281,"width":341.67169189453125,"x":-0.7235699892044067,"y":0.6113104820251465, "orientation" : 1,},
  "cow":{"height":54.599945068359375,"width":93.65663146972656,"x":-242.9600830078125,"y":395.20001220703125, "orientation" : -1,},
  "dog":{"height":95.67900085449219,"width":101.96998596191406,"x":-1.2189967632293701,"y":-0.5250012874603271, "orientation" : 1,},
  "cat":{"height":10.793039321899414,"width":13.366914749145508,"x":-0.0009134113788604736,"y":-0.000039577484130859375, "orientation" : 1,},
  "mouse":{"height":83.35600280761719,"width":56.37001037597656,"x":21.81699562072754,"y":8.321999549865723, "orientation" : -1,},
  "sleep":{"x":1.1710000038146973,"y":1.5679998397827148,"width":10.109003067016602,"height":9.314001083374023, "orientation" : 1},
  "star":{"x":-0.00013331958325579762,"y":0,"width":32.000850677490234,"height":32, "orientation" : 1},

  "glue":{"height":91.5,"width":85.0009994506836,"x":7.483999729156494,"y":4.5, "orientation" : 1,},
  "prism":{"height":65.30599975585938,"width":90,"x":5,"y":17.347000122070312, "orientation" : 1,},
  "lens":{"height":88.39999389648438,"width":88.29999542236328,"x":5.800000190734863,"y":5.800000190734863, "orientation" : 1,},
  "magnet":{"height":80.63399505615234,"width":82.78901672363281,"x":7.704988479614258,"y":8.058000564575195, "orientation" : 1,},
  "hammer":{"height":54.900001525878906,"width":47.29999923706055,"x":0.4000014662742615,"y":-7.400000095367432, "orientation" : 1,},
  "alarm":{"x":13.000001907348633,"y":11.199999809265137,"width":76.9000015258789,"height":76.90000915527344},
  "bleach":{"height":89.92599487304688,"width":61.970001220703125,"x":19.264999389648438,"y":5.036999702453613, "orientation" : 1,},
  "barn":{"height":90.1050033569336,"width":100.51300048828125,"x":-0.25600001215934753,"y":4.867000102996826, "orientation" : 1,},
  "swap":{"height":16,"width":16,"x":0,"y":0, "orientation" : 1,},

  "wand":{"x":62.853885650634766,"y":6.1133599281311035,"width":174.24891662597656,"height":280.1866149902344, "orientation" : 1},
  "brush":{"x":17.5,"y":7,"width":65,"height":86, "orientation" : 1},
  "mirror":{"x":5,"y":5,"width":90,"height":90, "orientation" : 1},
  "target":{"x":0,"y":0,"width":100,"height":100, "orientation" : 1},
  "expand":{"x":4,"y":4,"width":16,"height":16, "orientation" : 1},
  "collapse":{"x":3.4000000953674316,"y":3.5999999046325684,"width":17.100000381469727,"height":16.700000762939453, "orientation" : 1},
  "arrow":{"x":2.000000238418579,"y":13.034683227539062,"width":92,"height":69.99983215332031, "orientation" : 1},
  "eraser":{"x":2,"y":3,"width":20,"height":18, "orientation" : 1},
  "lock":{"x":7.5,"y":0.5,"width":33,"height":46.900001525878906, "orientation" : 1},
  "goal":{"x":37.29999923706055,"y":2.1000003814697266,"width":437.4000244140625,"height":507.8999938964844, "orientation" : 1},
};

export const failure_codes = {
  OUT_OF_MOVES : "You ran out of moves.",
  LOCKED_BOARD : "There are no more moves on the board.",
}

export const createSquare = ({square_id, parent_id, idx, depth = 1, leveldefs = {}, fill, direction, animal, empty = false, locked = false, star = false}) => {

  return {
    parent_id,
    idx,
    selected  : false,
    depth     : depth,
    direction : direction !== undefined ? direction : randomDirection(leveldefs.directions),
    animal    : animal    !== undefined ? animal    : randomAnimal(leveldefs.animals),
    fill      : fill      !== undefined ? fill      : randomColor(leveldefs.palette),
    id        : square_id,
    empty,
    locked,
    star
  }
}

export const createEmptySquare = ({parent_id, idx, depth, square_id}) => {
  return {
    parent_id,
    idx,
    id : square_id,
    depth,
    empty : true,
  }
}

export const randomBoard = (givenLeveldef = {}) => {

  const leveldef = {
    palette : defaultPalette,
    animals,
    directions,
    ...givenLeveldef
  }

  if (leveldef.level === 'editor') {
    return emptyBoard();
  }

  while (1) {
    let board = [1,2,3,4,5,6,7,8].reduce( (acc, square_id, idx) => {
        acc[square_id] = createSquare(
          {
            parent_id : 0,
            idx,
            depth : 1,
            square_id,
            fill : randomColor(leveldef.palette),
            animal : randomAnimal(leveldef.animals),
            direction : randomDirection(leveldef.directions)
          }
        );
        return acc;
      },
      { '0' : { parent_id : null, idx : 0, depth : 0 } }
    );

    if (checkSquaresForSet(board) === true) {
      return board;
    }
  }

}

export const emptyBoard = () => {
  return [1,2,3,4,5,6,7,8].reduce( (acc, square_id, idx) => {
      acc[square_id] = createEmptySquare({parent_id : 0, idx, depth : 1, square_id, empty : true});
      return acc;
    },
    { '0' : { parent_id : null, idx : 0, depth : 0, id : 0 } }
  );

}

export let checkSquaresForSet = (squaresObj) => {

  const squares = Object.values(squaresObj);
  const hierarchy = getSquaresHierarchy( { squares : squaresObj } );

  const NUM_SQUARES = Object.keys(squares).length;

  for (let i = 0; i < NUM_SQUARES; i++) {

    let square1 = squares[i];
    if (square1.dead || square1.empty || hierarchy[square1.id] !== undefined) {
      continue;
    }
    else if (square1.star) {
      return true;
    }

    for (let j = i + 1; j < NUM_SQUARES; j++) {

      let square2 = squares[j];
      if (square2.dead || square2.empty || hierarchy[square2.id] !== undefined) {
        continue;
      }
      else if (square2.star) {
        return true;
      }

      for (let k = j + 1; k < NUM_SQUARES; k++) {

        let square3 = squares[k];
        if (square3.dead || square3.empty || hierarchy[square3.id] !== undefined) {
          continue;
        }
        else if (square3.star) {
          return true;
        }

        const isSet = PROPERTIES.reduce( (acc, prop) => {

          let inc = 0;

          if (square1[prop] === square2[prop] && square2[prop] === square3[prop]) {
            inc = 2;
          }
          else if (square1[prop] !== square2[prop] && square1[prop] !== square3[prop] && square2[prop] !== square3[prop]) {
            inc = 1;
          }

          return acc * inc;

        }, 1);

        if (isSet) {
          return true;
        }
      }
    }
  }

  return false;

}



// WEBPACK FOOTER //
// ./src/utilities.js